export default {
  //staging: "staging.",
  //sadadCallback: "http://localhost:8083/payment/sadadcallback",

  staging: "",
  sadadCallback: "https://apppwa.iranecar.com/payment/sadadcallback",
};
